export const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
export const GET_TRANSACTION = 'GET_TRANSACTION';
export const FLAG_GETTING_TRANSACTIONS = 'FLAG_GETTING_TRANSACTIONS';
export const FLAG_TRANSACTION_ACTIVITY = 'FLAG_TRANSACTION_ACTIVITY';
export const CLEAR_TRANSACTION = 'CLEAR_TRANSACTION';
export const CLEAR_TRANSACTIONS = 'CLEAR_TRANSACTIONS';
